"use client";

import type { ReactNode } from "react";
import { useI18n } from "@/lib/i18n";

/** Ensures blocking errors always tell the customer what to do next. */
export function ErrorRecoveryHint({ children }: { children?: ReactNode }) {
  const { t } = useI18n();
  return (
    <span className="error-recovery-hint">
      {t("errors.recovery")}
      {children ? <> {children}</> : null}
    </span>
  );
}
